import React from 'react'

const Biografia = () => {
  return (
    <div>Biografia</div>
  )
}

export default Biografia